import { QueryStatus } from '@tanstack/react-query';
import { QuestionnaireFormResponse } from 'types/ui';
import getQuestionnaireApiCall from 'api/calls/getQuestionnaireApiCall';
import useAuth from './useAuth';
import useProtectedQuery from './useProtectedQuery';

interface UseQuestionnaireQuery {
  status: QueryStatus;
  questionnaire?: QuestionnaireFormResponse;
}

const useQuestionnaireQuery = (): UseQuestionnaireQuery => {
  const { token } = useAuth();
  const query = useProtectedQuery(
    ['getQuestionnaireApiCall', token],
    getQuestionnaireApiCall,
    {
      staleTime: 5 * 60 * 1000,
    },
  );

  return {
    status: query.status,
    questionnaire: query.data,
  };
};

export default useQuestionnaireQuery;
